import React from 'react';
import { useAuth } from '../context/AuthContext';

export const GoogleButton = ({ label = 'Lanjutkan dengan Google' }) => {
  const { loginWithGoogle } = useAuth();
  return (
    <>
      <div className="flex items-center gap-3 my-5">
        <div className="flex-1 h-px bg-cream-200" />
        <span className="text-xs text-sage-400">atau</span>
        <div className="flex-1 h-px bg-cream-200" />
      </div>
      <button type="button" onClick={loginWithGoogle} data-testid="google-login-button"
        className="w-full h-11 rounded-full border border-cream-200 bg-white hover:bg-cream-50 transition-colors flex items-center justify-center gap-3 text-sm font-medium text-sage-700">
        <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
          <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9.1 3.5l6.8-6.8C35.8 2.4 30.3 0 24 0 14.6 0 6.5 5.4 2.6 13.3l7.9 6.1C12.4 13.6 17.7 9.5 24 9.5z"/>
          <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.1-.4-4.5H24v9h12.7c-.6 3-2.3 5.5-4.8 7.2l7.6 5.9c4.5-4.1 7-10.2 7-17.6z"/>
          <path fill="#FBBC05" d="M10.5 28.6A14.5 14.5 0 0 1 9.5 24c0-1.6.3-3.2.8-4.6l-7.9-6.1A24 24 0 0 0 0 24c0 3.9.9 7.5 2.6 10.7l7.9-6.1z"/>
          <path fill="#34A853" d="M24 48c6.3 0 11.7-2.1 15.6-5.7l-7.6-5.9c-2.1 1.4-4.8 2.3-8 2.3-6.3 0-11.6-4.1-13.5-9.9l-7.9 6.1C6.5 42.6 14.6 48 24 48z"/>
        </svg>
        {label}
      </button>
    </>
  );
};
